<app-modal-base [title]="dialogTitle" (onSubmitEvent)="onSubmit()" [loading]="isLoading">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <p>{{ message }}</p>
  </div>
</ng-template>